import {
  MDBAlert,
  MDBBtn,
  MDBDatatable,
  MDBIcon,
  MDBSpinner,
} from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import {
  downloadFaxFile,
  downloadGroupFaxFile,
  getForwardFaxInfo,
  getForwardGroupFaxInfo,
  resendGroupFax,
  resendUserFax,
  sentFaxDetails,
  sentGroupFaxDetails,
} from "../../../apiclients/streamsapi_bridge";
import { useNavigate } from "react-router";
import TopSuccess from "../../../components/header/TopSuccess";
import TopMessage from "../../../components/header/TopMessage";
import PopupLoader from "../PopupLoader";
import DeleteSntRecFax from "../phonesystem/DeleteSntRecFax";
import SendAFax from "./SendAFax";
import { FaxResend } from "../../../components/images";

function SentFax({
  uniqueid,
  groupFaxFlag,
  faxDomain,
  primaryFax,
  userList,
  faxPhoneNums,
  isActive,
  groupname,
}) {
  const [isloading, setIsloading] = useState(false);
  const [internalError, setInternalError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const navigate = useNavigate();
  const [rerender, setrerender] = useState(true);
  const [successMessage, setSuccessMessage] = useState("");
  const [sentFax, setSentFax] = useState([]);
  const [deleteFax, setDeleteFax] = useState(false);
  const dtogglePopup = () => setDeleteFax(!deleteFax);
  const [selectedFaxId, setSelectedFaxId] = useState("");
  const [forwardFax, setForwardFax] = useState(false);
  const forwardFaxPopup = () => setForwardFax(!forwardFax);
  const [fileName, setFileName] = useState("");

  function deletethisFax(evntData, faxid) {
    evntData?.preventDefault();
    evntData?.stopPropagation();
    setSelectedFaxId(faxid);
    dtogglePopup();
  }

  useEffect(() => {
    if (successMessage) {
      setTimeout(() => {
        setSuccessMessage("");
      }, 5000);
    }
  }, [successMessage]);

  useEffect(() => {
    if ((uniqueid && uniqueid !== "" && isActive) || rerender) {
      getSentFaxDetails();
      setrerender(false);
      // setsentFlag(false);
    }
  }, [uniqueid, isActive, rerender]);

  async function getSentFaxDetails() {
    try {
      setIsloading(true);
      setInternalError(false);

      let response = null;
      if (groupFaxFlag) {
        response = await sentGroupFaxDetails(
          JSON.parse(sessionStorage.getItem("admin_session")).siteid,
          uniqueid
        );
      } else {
        response = await sentFaxDetails(
          JSON.parse(sessionStorage.getItem("admin_session")).siteid,
          uniqueid
        );
      }

      const rawData = await response.json();
      console.log("sentFaxDetails details :::::: " + JSON.stringify(rawData));
      if (response.status === 200) {
        if (groupFaxFlag) {
          setSentFax(rawData?.sentGrpfaxdetail ?? []);
        } else {
          setSentFax(rawData?.sentfaxdetail ?? []);
        }
      } else if (response.status === 500) {
        setInternalError(true);
      } else {
        // navigate("/");
        setInternalError(true);
      }
    } catch (e) {
      console.log(`Unable to process the request:${e}`);
      setInternalError(true);
    } finally {
      setIsloading(false);
    }
  }

  async function handleResendFax(e, faxid) {
    e?.preventDefault();
    e?.stopPropagation();
    try {
      setIsloading(true);
      setInternalError(false);
      let response = null;
      if (groupFaxFlag) {
        response = await resendGroupFax(
          JSON.parse(sessionStorage.getItem("admin_session")).siteid,
          faxid,
          1
        );
      } else {
        response = await resendUserFax(
          JSON.parse(sessionStorage.getItem("admin_session")).siteid,
          faxid
        );
      }
      const rawData = await response.json();
      console.log("resendUserFax response :::::: " + JSON.stringify(rawData));
      setIsloading(false);
      if (response.status === 200) {
        setSuccessMessage(rawData.message);
      } else if (response.status === 500) {
        setInternalError(true);
        setErrorMessage(rawData?.message ?? "");
      } else {
        // navigate("/");
        setInternalError(true);
        setErrorMessage(rawData?.message ?? "");
      }
    } catch (e) {
      console.log(`Unable to process the request:${e}`);
      setInternalError(true);
    } finally {
    }
  }

  async function handleDownload(e, faxid, fileName) {
    e.preventDefault();
    e.stopPropagation();
    try {
      let apiResponse = null;
      if (groupFaxFlag) {
        apiResponse = await downloadGroupFaxFile(
          JSON.parse(sessionStorage.getItem("admin_session")).siteid,
          faxid
        );
      } else {
        apiResponse = await downloadFaxFile(
          JSON.parse(sessionStorage.getItem("admin_session")).siteid,
          faxid
        );
      }

      let filename = fileName;
      let saverepeMsg = (await apiResponse?.json()) ?? null;

      if (
        apiResponse.status == 200 &&
        !(saverepeMsg && saverepeMsg.status === "failed")
      ) {
        const fileUrl = URL.createObjectURL(await apiResponse.blob());
        const a = document.createElement("a");
        a.href = fileUrl;
        a.download = filename;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else {
        setInternalError(true);
        setErrorMessage(saverepeMsg?.message ?? "");
      }
    } catch (error) {
      console.log("Error ::::::::: " + error);
    }
  }

  async function handleForwardFax(e, filename, faxid) {
    e.preventDefault();
    e.stopPropagation();
    setFileName(filename);
    setSelectedFaxId(faxid);

    // try {
    //   setIsloading(true);
    //   setInternalError(false);

    //   let response = null;
    //   if (groupFaxFlag) {
    //     response = await getForwardGroupFaxInfo(
    //       JSON.parse(sessionStorage.getItem("admin_session")).siteid,
    //       uniqueid
    //     );
    //   } else {
    //     response = await getForwardFaxInfo(
    //       JSON.parse(sessionStorage.getItem("admin_session")).siteid,
    //       uniqueid
    //     );
    //   }

    //   const rawData = await response.json();
    //   console.log(
    //     "getForwardFaxInfo details :::::: " + JSON.stringify(rawData)
    //   );
    //   if (response.status === 200) {
    //     // if (groupFaxFlag) {
    //     //   setSentFax(rawData?.sentGrpfaxdetail ?? []);
    //     // } else {
    //     //   setSentFax(rawData?.sentfaxdetail ?? []);
    //     // }
    //   } else if (response.status === 500) {
    //     setInternalError(true);
    //   } else {
    //     // navigate("/");
    //     setInternalError(true);
    //   }
    // } catch (e) {
    //   console.log(`Unable to process the request:${e}`);
    //   setInternalError(true);
    // } finally {
    //   setIsloading(false);
    // }

    forwardFaxPopup();
  }

  const processdrows = sentFax.map((fax, index) => {
    const baseRow = {
      faxInfo: fax,
      sno: index + 1,
      fileName: fax.file_name,
      faxPages: fax?.fax_pages ? parseInt(fax.fax_pages) : 0,
      from: fax.From + "",
      to: fax.To + "",
      date: fax.date + "",
      time: fax.time + "",
      status: fax.status,
      size: fax?.size ? parseInt(fax.size) : 0,
      actions: (
        <div className="d-flex align-items-center">
          <div
            className="custom-hover-bg p-1 cursor-pointer DownloadToolTip"
            onClick={(e) => handleDownload(e, fax.fax_id, fax.file_name)}
          >
            <MDBIcon icon="download" className="fs-5" color="primary" />
          </div>
          <div
            className="custom-hover-bg ms-3 p-1 cursor-pointer ShareToolTip"
            onClick={(e) => handleForwardFax(e, fax.file_name, fax.fax_id)}
          >
            <MDBIcon className="fs-5" fas icon="share" color="primary" />
          </div>
          <div
            className="custom-hover-bg ms-3 p-1 cursor-pointer deleteToolTip"
            onClick={(e) => deletethisFax(e, fax.fax_id)}
          >
            <MDBIcon color="primary" className="fs-5" icon="trash" />
          </div>
          <div
            className="custom-hover-bg ms-3 p-1 cursor-pointer resendToolTip"
            onClick={(e) => handleResendFax(e, fax.fax_id)}
          >
            {fax.status !== "In Progress" && (
              <img
                src={FaxResend}
                alt=""
                // onClick={(e) => handleResendFax(e, fax.fax_id)}
              />
            )}
          </div>
        </div>
      ),
    };

    if (groupFaxFlag) {
      return {
        ...baseRow,
        fromuser: fax.From_user + "",
      };
    } else {
      return {
        ...baseRow,
        faxType: fax.fax_type + "",
      };
    }
  });
  let actionData2 = {};
  if (groupFaxFlag) {
    actionData2 = {
      columns: [
        { label: "S.No", field: "sno" },
        { label: "File Name", field: "fileName" },
        { label: "Fax Pages", field: "faxPages" },
        { label: "From", field: "from" },
        { label: "From User", field: "fromuser" },
        { label: "To", field: "to" },
        { label: "Date", field: "date" },
        { label: "Time", field: "time" },
        { label: "Status", field: "status", sort: false },
        { label: "Size(KB)", field: "size" },
        { label: "Actions", field: "actions", sort: false },
      ],
      rows: processdrows,
    };
  } else {
    actionData2 = {
      columns: [
        { label: "S.No", field: "sno" },
        { label: "File Name", field: "fileName" },
        { label: "Fax Pages", field: "faxPages" },
        { label: "From", field: "from" },
        { label: "To", field: "to" },
        { label: "Date", field: "date" },
        { label: "Time", field: "time" },
        { label: "Status", field: "status", sort: false },
        { label: "Size(KB)", field: "size" },
        { label: "Fax Type", field: "faxType", sort: false },
        { label: "Actions", field: "actions", sort: false },
      ],
      rows: processdrows,
    };
  }
  return (
    <>
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
      <div className="w-100 mt-3 usersFaxDataTable">
        <div className="actionbar"></div>
        <MDBDatatable
          search
          fixedHeader
          sortField="Date"
          sortOrder="desc"
          entries={50}
          hover
          data={actionData2}
          // fullPagination
        />
      </div>
      {successMessage && (
        <>
          <MDBAlert
            open
            className="alert-center"
            color="success"
            autohide
            position="bottom-right"
            delay={5000}
          >
            <i className="fas fa-times-circle me-3"></i>
            <span className="alert-msg">{successMessage}</span>
          </MDBAlert>
        </>
      )}
      {deleteFax && (
        <PopupLoader
          title={"Delete Fax"}
          content={
            <DeleteSntRecFax
              faxid={selectedFaxId}
              setSuccessMessage={setSuccessMessage}
              setrerender={setrerender}
              onClose={dtogglePopup}
              groupFaxFlag={groupFaxFlag}
            />
          }
          onShow={setDeleteFax}
          onClose={dtogglePopup}
        />
      )}
      {forwardFax && (
        <PopupLoader
          title={"Forward Fax"}
          size={"lg"}
          content={
            <SendAFax
              faxPhoneNums={faxPhoneNums}
              uniqueid={uniqueid}
              faxDomain={faxDomain}
              primaryFax={primaryFax}
              groupFaxFlag={groupFaxFlag}
              userList={userList}
              forwardFlag={true}
              existFileName={fileName}
              groupname={groupname}
              selectedFaxId={selectedFaxId}
              onClose = {forwardFaxPopup}
            />
          }
          onShow={setForwardFax}
          onClose={forwardFaxPopup}
        />
      )}

      {internalError && (
        <MDBAlert
          open
          className="alert-center"
          color="danger"
          autohide
          position="bottom-right"
          delay={3000}
          onClose={() => setInternalError(false)}
        >
          {errorMessage ? errorMessage : "Internal Server Error"}
        </MDBAlert>
      )}
    </>
  );
}

export default SentFax;
